// Global OPS workspace background.
//
// The previous implementation used a full-screen photographed room with a
// large purple octagon. That was useful when the dashboard was primarily a
// glassmorphism concept, but it competes with production content. The working
// UI now uses a quiet theme-aware surface: soft ambient colour, a barely
// visible geometric grid and subtle noise. Brand imagery stays in intentional
// places (auth, opening animation, icons), not behind operational data.
export function ParallaxBackground() {
  return (
    <div className="ops-dashboard-backdrop" aria-hidden="true">
      <div className="ops-dashboard-glow ops-dashboard-glow-primary" />
      <div className="ops-dashboard-glow ops-dashboard-glow-secondary" />
      <div className="ops-dashboard-grid" />
      <div className="ops-dashboard-noise" />
    </div>
  )
}
